<div id="users" class="page-layout blank simple" fxLayout="column">
  <!--HEADER-->
  <div class="header-users">
    <div class="header-container">
      <div
        class="name field"
        [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
        {{ 'USERS.TITLE' | translate }}
      </div>
      <div class="etab">
        <div class="button-section">
          @if (showHideFilter) {
            <button
              class="toggleFilters export-btn search-button-action"
              (click)="toggleFilters()">
              <mat-icon style="color: white">filter_list</mat-icon>
            </button>
          }
          <button
            (click)="onRefreshClick()"
            mat-icon-button
            aria-label="refresh"
            class="export-btn search-button-action">
            <mat-icon>refresh</mat-icon>
          </button>
          <button
            mat-icon-button
            [matMenuTriggerFor]="mainMenu"
            aria-label="export"
            class="export-btn search-button-action">
            <mat-icon class="arrow-icon">more_vert</mat-icon>
          </button>
          <mat-menu #mainMenu="matMenu" class="main-menu">
            <!-- Clear option outside List submenu -->
            <button mat-menu-item (click)="onClearFilterClick()">
              <mat-icon>clear</mat-icon>{{ 'TABLE.DELETEFILTER' | translate }}
            </button>
            <!-- List submenu -->
            <button mat-menu-item [matMenuTriggerFor]="listMenu">
              <mat-icon>list</mat-icon>{{ 'TABLE.LIST' | translate }}
            </button>
            <!-- Image submenu -->
            @if (checkPermission()) {
              <button mat-menu-item [matMenuTriggerFor]="imageMenu">
                <mat-icon>image</mat-icon>{{ 'TABLE.IMAGES' | translate }}
              </button>
            }
          </mat-menu>

          <!-- List submenu -->
          <mat-menu #listMenu="matMenu">
            <button mat-menu-item (click)="exportDataWithTimeout(false)">
              <mat-icon>assignment</mat-icon>{{ 'TABLE.EXPORTALL' | translate }}
            </button>
            <button mat-menu-item (click)="exportDataWithTimeout(true)">
              <mat-icon>filter</mat-icon>{{ 'TABLE.EXPORTSELECT' | translate }}
            </button>
            <!-- Image submenu -->
            @if (checkPermissionITManager2G()) {
              <button
                mat-menu-item
                (click)="exportDataWithTimeoutInfraPcProfi(false)">
                <mat-icon>table_chart</mat-icon
                >{{ 'TABLE.EXPORTSELECTINFRAALL' | translate }}
              </button>
              <button
                mat-menu-item
                (click)="exportDataWithTimeoutInfraPcProfi(true)">
                <mat-icon>table_chart</mat-icon
                >{{ 'TABLE.EXPORTSELECTINFRASELECT' | translate }}
              </button>
            }
          </mat-menu>

          <!-- Image submenu -->
          <mat-menu #imageMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="exportAllImages()">
              <mat-icon>image</mat-icon
              >{{ 'TABLE.EXPORTIMAGESSELECTION' | translate }}
            </button>
            @if (isS2G()) {
              <button mat-menu-item (click)="isISM(); exportAllImages()">
                <mat-icon>image</mat-icon
                >{{ 'TABLE.EXPORTALLIMAGESID' | translate }}
              </button>
            }
            <button mat-menu-item (click)="exportAllImages(true)">
              <mat-icon>image</mat-icon
              >{{ 'TABLE.EXPORTALLIMAGESSELECTION' | translate }}
            </button>
            <button mat-menu-item (click)="isISM(); exportAllImages(true)">
              <mat-icon>image</mat-icon
              >{{ 'TABLE.EXPORTALLIMAGESGEID' | translate }}
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    @if (showFilters) {
      <div class="search-section">
        <div class="search-field" [@fadeInOut]>
          <div class="search-wrapper">
            <div class="search">
              <div class="field">
                <div class="box-container">
                  <mat-form-field
                    appearance="fill"
                    class="simplified"
                    style="margin-top: 15px">
                    <mat-select
                      class="select-etab-users"
                      [formControl]="statusSearchField"
                      [placeholder]="
                        'USERS.SINGLE.INFO.STATUSTITLE' | translate
                      "
                      (selectionChange)="onSelectionChange()">
                      <mat-option value="all">{{
                        'USERS.SINGLE.INFO.STATUSALL' | translate
                      }}</mat-option>
                      <mat-option value="active">{{
                        'USERS.SINGLE.INFO.STATUSON' | translate
                      }}</mat-option>
                      <mat-option value="inactive">{{
                        'USERS.SINGLE.INFO.STATUSOFF' | translate
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="classSearchField"
                matInput
                placeholder="{{ 'TABLE.SEARCH.CLASS' | translate }}" />
            </div>
          </div>
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="firstNameSearchField"
                matInput
                placeholder="{{ 'TABLE.SEARCH.FIRSTNAME' | translate }}" />
            </div>
          </div>
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="lastNameSearchField"
                matInput
                placeholder="{{ 'TABLE.SEARCH.NAME' | translate }}" />
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <!-- HEADER END -->
  @if (isLoading) {
    <mat-progress-bar
      color="accent"
      mode="indeterminate"
      class="mat-progress-bar"></mat-progress-bar>
  }
  @if (!isLoading && users) {
    <div class="content" fxLayout="row wrap">
      <!-- CONTENT CARD -->
      <div class="content-card" fxFill>
        @if (!isLoading) {
          <div class="mat-elevation-z8">
            <table
              id="gridContainer"
              mat-table
              [dataSource]="dataSource"
              matSort
              (matSortChange)="sortData($event)"
              multiTemplateDataRows>
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)"
                    [aria-label]="checkboxLabel(element)">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="mustChangePwd">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'TABLE.USERS.HEADER.STATUS' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable">
                  @if (element.mustChangePwd === false) {
                    <div class="current-value">
                      <mat-icon
                        matTooltip="{{
                          'GENERAL.TOOLTIP.USERS.CHECK' | translate
                        }}"
                        class="checkIcon"
                        >check_circle</mat-icon
                      >
                    </div>
                  }
                  @if (element.mustChangePwd === true) {
                    <div class="current-value">
                      <mat-icon
                        matTooltip="{{
                          'GENERAL.TOOLTIP.USERS.WARNING' | translate
                        }}"
                        class="warningIcon"
                        >warning</mat-icon
                      >
                    </div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="groupEtablissement">
                <th mat-header-cell *matHeaderCellDef class="chipListColumn">
                  {{ 'USERS.SINGLE.INFO.SCHOOL' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable chipListColumn">
                  @if (
                    element.groupEtablissement[0] !== '-' &&
                    element.groupEtablissement.length <= 5
                  ) {
                    <mat-chip-listbox>
                      @for (info of element.groupEtablissement; track info) {
                        <mat-chip class="info-chip">
                          {{ info }}
                        </mat-chip>
                      }
                    </mat-chip-listbox>
                  }
                  @if (
                    element.groupEtablissement[0] !== '-' &&
                    element.groupEtablissement.length > 5
                  ) {
                    <mat-chip-listbox>
                      @for (
                        info of element.groupEtablissement | slice: 0 : 5;
                        track info
                      ) {
                        <mat-chip class="info-chip">
                          {{ info }}
                        </mat-chip>
                      }
                      <mat-chip
                        class="info-chip moreElements"
                        (click)="toggleRow(element, $event)">
                        +{{ element.groupEtablissement.length - 5 }}
                        {{ 'USERS.SINGLE.INFO.MORE' | translate }}
                      </mat-chip>
                    </mat-chip-listbox>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="classeArray">
                <th mat-header-cell *matHeaderCellDef class="chipListColumn">
                  {{ 'USERS.SINGLE.INFO.CLASS' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable chipListColumn">
                  @if (
                    element.classes[0] !== '-' && element.classes.length <= 5
                  ) {
                    <mat-chip-listbox>
                      @for (info of element.classes; track info) {
                        <mat-chip class="info-chip">
                          {{ info }}
                        </mat-chip>
                      }
                    </mat-chip-listbox>
                  }
                  @if (
                    element.classes[0] !== '-' && element.classes.length > 5
                  ) {
                    <mat-chip-listbox>
                      @for (
                        info of element.classes | slice: 0 : 5;
                        track info
                      ) {
                        <mat-chip class="info-chip">
                          {{ info }}
                        </mat-chip>
                      }
                      <mat-chip
                        class="info-chip moreElements"
                        (click)="toggleRow(element, $event)">
                        +{{ element.classes.length - 5 }}
                        {{ 'USERS.SINGLE.INFO.MORE' | translate }}
                      </mat-chip>
                    </mat-chip-listbox>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="hasProfilePicture">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'USERS.SINGLE.INFO.HASPROFILEPICTURE' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable profileImage">
                  @if (element.hasProfilePicture === true) {
                    <div
                      class="tooltip"
                      (mouseenter)="getImageForToolTip(element.oid)">
                      <mat-icon class="checkIcon">camera_alt</mat-icon>
                      @if (isImageLoaded) {
                        <span class="tooltiptext">
                          <img
                            [src]="imageToolTip"
                            class="tooltip-image"
                            alt="Profile image" />
                        </span>
                      }
                    </div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="firstName">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header="firstName"
                  class="sortable">
                  {{ 'USERS.SINGLE.INFO.FIRSTNAME' | translate }}
                  <mat-icon
                    [style.color]="
                      sortedValue !== 'firstName' ? '#757575' : 'transparent'
                    "
                    class="sort-icon"
                    >sort</mat-icon
                  >
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable">
                  @if (element.avsAlign === false) {
                    <div class="name-wrapper">
                      <span class="name-text">{{ element.firstName }}</span>
                      <mat-icon
                        [matTooltip]="
                          'USERS.SINGLE.TABS3.AVS_MISALIGNED' | translate
                        "
                        class="warningIcon"
                        >warning</mat-icon
                      >
                    </div>
                  } @else {
                    <span class="name-text">{{ element.firstName }}</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="lastName">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header="lastName"
                  class="sortable">
                  {{ 'USERS.SINGLE.INFO.LASTNAME' | translate }}
                  <mat-icon
                    [style.color]="
                      sortedValue !== 'lastName' ? '#757575' : 'transparent'
                    "
                    class="sort-icon"
                    >sort</mat-icon
                  >
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable">
                  {{ element.lastName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'USERS.SINGLE.INFO.USERNAME' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable">
                  {{ element.userName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="activationCode">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'USERS.SINGLE.INFO.INITIALPASSWORD' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable">
                  {{ element.activationCode }}
                </td>
              </ng-container>
              <ng-container matColumnDef="officialemail">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'USERS.SINGLE.INFO.EMAIL' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)"
                  class="clickable">
                  {{ element.officialEmail }}
                </td>
              </ng-container>
              <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef></th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="onRowClick(element)">
                  <button mat-icon-button (click)="toggleRow(element, $event)">
                    <mat-icon>more_horiz</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="expandedDetail">
                <td
                  class="clickable"
                  mat-cell
                  *matCellDef="let element"
                  [attr.colspan]="displayedColumns.length">
                  @if (expandedElement === element) {
                    <div class="expanded-detail">
                      @if (element.groupEtablissement[0] !== '-') {
                        <div class="expanded-detail-element">
                          <strong>
                            {{ 'USERS.SINGLE.INFO.SCHOOL' | translate }}:
                          </strong>
                          <mat-chip-listbox>
                            @for (
                              info of element.groupEtablissement;
                              track info
                            ) {
                              <mat-chip class="info-chip">
                                {{ info }}
                              </mat-chip>
                            }
                          </mat-chip-listbox>
                        </div>
                      }
                      @if (
                        windowWidth < 1700 && element.activationCode !== null
                      ) {
                        <p class="expanded-detail-element">
                          <strong>
                            {{
                              'USERS.SINGLE.INFO.INITIALPASSWORD' | translate
                            }}:
                          </strong>
                          {{ element.activationCode }}
                        </p>
                      }
                      @if (
                        (windowWidth < 1500 && element.classes[0] !== '-') ||
                        element.classes.length > 5
                      ) {
                        <div class="expanded-detail-element">
                          <strong>
                            {{ 'USERS.SINGLE.INFO.CLASS' | translate }}:
                          </strong>
                          <mat-chip-listbox>
                            @for (info of element.classes; track info) {
                              <mat-chip class="info-chip">
                                {{ info }}
                              </mat-chip>
                            }
                          </mat-chip-listbox>
                        </div>
                      }
                      @if (
                        windowWidth < 1300 && element.officialEmail !== null
                      ) {
                        <p class="expanded-detail-element">
                          <strong>
                            {{ 'USERS.SINGLE.INFO.EMAIL' | translate }}:
                          </strong>
                          {{ element.officialEmail }}
                        </p>
                      }
                      @if (windowWidth < 850 && element.userName !== null) {
                        <p class="expanded-detail-element">
                          <strong>
                            {{ 'USERS.SINGLE.INFO.USERNAME' | translate }}:
                          </strong>
                          {{ element.userName }}
                        </p>
                      }
                      @if (
                        windowWidth < 600 && element.hasProfilePicture === true
                      ) {
                        <div class="expanded-detail-element">
                          <strong>
                            {{
                              'USERS.SINGLE.INFO.HASPROFILEPICTURE' | translate
                            }}:
                          </strong>
                          <div
                            class="tooltip"
                            (mouseenter)="getImageForToolTip(element.oid)">
                            <mat-icon class="checkIcon">camera_alt</mat-icon>
                            @if (isImageLoaded) {
                              <span class="tooltiptext">
                                <img
                                  [src]="imageToolTip"
                                  class="tooltip-image"
                                  alt="Profile image" />
                              </span>
                            }
                          </div>
                        </div>
                      }
                      @if (windowWidth < 500 && element.lastName !== null) {
                        <p class="expanded-detail-element">
                          <strong>
                            {{ 'USERS.SINGLE.INFO.LASTNAME' | translate }}:
                          </strong>
                          {{ element.lastName }}
                        </p>
                      }
                    </div>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="
                  let row;
                  let index = dataIndex;
                  columns: displayedColumns
                "
                class="element-row"
                [ngClass]="{ alternate: index % 2 === 0 }"></tr>
              <tr
                mat-row
                *matRowDef="
                  let row;
                  let index = dataIndex;
                  columns: ['expandedDetail']
                "
                class="detail-row"
                [ngClass]="{ alternate: index % 2 === 0 }"
                (click)="onRowClick(row)"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td
                  class="mat-cell noDataText"
                  [attr.colspan]="displayedColumns.length">
                  {{ 'TABLE.NODATAMESSAGE' | translate }}
                </td>
              </tr>
            </table>
            <div class="dataGridFooter">
              <div class="pageSize-container">
                <ul class="pageSize">
                  @for (i of allowedPageSize; track $index) {
                    <li
                      tabindex=""
                      (click)="onPageSizeClick(i)"
                      (keydown)="onPageSizeClick(i)"
                      [ngClass]="{ active: selectedPageSize === i }">
                      {{ i }}
                    </li>
                  }
                </ul>
              </div>
              <div id="paginationContainer" class="pagination-container">
                <div>
                  {{ 'TABLE.PAGINATION.PAGE' | translate }}
                  {{ currentPage + 1 }}
                </div>
                <button
                  (click)="onPreviousPageclick()"
                  [disabled]="currentPageForView === 1">
                  <mat-icon
                    matTooltip="{{
                      'TABLE.PAGINATION.PREVIOUSPAGE' | translate
                    }}"
                    >chevron_left</mat-icon
                  >
                </button>
                <button (click)="onNextPageClick()" [disabled]="!hasMoreUsers">
                  <mat-icon
                    matTooltip="{{ 'TABLE.PAGINATION.NEXTPAGE' | translate }}"
                    >chevron_right</mat-icon
                  >
                </button>
              </div>
            </div>
          </div>
        }
      </div>
      <!-- / CONTENT CARD -->
    </div>
  }
  @if (errorGetUsers) {
    <div class="message-box error user-created">
      <app-error-message [error]="error.error" />
    </div>
  }
</div>
